var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<pkp-network-point-header network-point=\"context.selectedNetworkPoint\"></pkp-network-point-header>\n";
var id1="app/comfort-bid/comfort-bid-wizard-input-summary.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;